module.exports = __webpack_public_path__ + "img/Flag_of_Fiji.4541ca5b.svg";